import { createPortal } from "react-dom";
import { Loader2 } from "lucide-react";

import useSocketMessage from "@/store/socket-message";

const SocketStatus = () => {
    const { messages, connectionStatus } = useSocketMessage();

    if (connectionStatus === "Connected" && messages.length > 0) {
        // Extract the page name from the last message if available
        const lastMessage = messages[messages.length - 1];
        let pageName = lastMessage;

        // Try to extract just the URL/page name from the message
        // If the message contains a URL, extract just the domain/path
        if (lastMessage.includes("http") || lastMessage.includes("www")) {
            try {
                const urlMatch = lastMessage.match(/(https?:\/\/[^\s]+)/i);
                if (urlMatch) {
                    const url = new URL(urlMatch[0]);
                    pageName = url.hostname + url.pathname.replace(/\/$/, "");
                }
            } catch (e) {
                // If URL parsing fails, fall back to the original message
                pageName = lastMessage;
            }
        } else {
            // Use the original message if it doesn't contain a URL
            pageName = lastMessage;
        }

        return createPortal(
            <div className="fixed bottom-4 right-4 z-[100] flex w-80 flex-col items-start gap-2 rounded-lg border bg-white p-4 shadow-lg animate-in slide-in-from-bottom duration-300">
                <div className="flex items-center gap-2">
                    <Loader2 className="h-4 w-4 animate-spin text-blue-500" />
                    <span className="text-sm font-medium text-gray-900">Crawling in progress</span>
                </div>
                <p className="text-xs text-gray-600 truncate max-w-full">{pageName}</p>
            </div>,
            document.body
        );
    }
    return null;
};

export default SocketStatus;
